import React, { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../../services/api";
import { stripeBannerVariant } from "../../helpers/functions";
import { RevAlert, RevButton } from "../ds";

const TONE = { revoked: 'err', migration: 'warn', validation: 'warn' };

const StripeValidationBanner = ({ user }) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [loading, setLoading] = useState(false);

    // Tres avisos excluyentes: cuenta revocada, Express pendiente de migrar y
    // Standard sin validar. La prioridad la decide stripeBannerVariant.
    const variant = stripeBannerVariant(user);

    const goToStripeAccount = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get("/stripe-account-url");
            if (res.data?.url?.includes("https://")) {
                window.open(res.data.url, '_blank');
            } else {
                console.error('Error al obtener la URL de Stripe');
            }
        } catch (error) {
            console.error('Error al obtener la URL de Stripe:', error);
        } finally {
            setLoading(false);
        }
    };

    // En Cobros no se pinta: es la pantalla a la que lleva el propio aviso
    // (incluidos los retornos /account/photo-sale/stripe-link-*, que acaban en home).
    if (!variant || pathname.startsWith('/account/photo-sale')) {
        return null;
    }

    // El boton de validacion sigue a la derecha (accion externa); el enlace a
    // Cobros cuelga del texto, alineado a la izquierda con titulo y mensaje.
    const actions = variant === 'validation'
        ? <RevButton variant="secondary" onClick={goToStripeAccount} loading={loading}>
            {t('stripe.validation.button')}
        </RevButton>
        : null;

    return (
        <div className="rev-app__banner">
            <RevAlert
                tone={TONE[variant]}
                title={t(`stripe.${variant}.title`)}
                actions={actions}
            >
                <p>{t(`stripe.${variant}.message`)}</p>
                {!actions && (
                    <div className="rev-alert__actions">
                        <RevButton as={Link} to="/account/photo-sale/home" size="sm">
                            {t(`stripe.${variant}.button`)}
                        </RevButton>
                    </div>
                )}
            </RevAlert>
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.usersReducer.user
});

export default connect(mapStateToProps)(StripeValidationBanner);
